import { VerifyCouponRequest } from '@ce-openapi/business-subscription-service-ts-axios-client';
import { axios } from '@pukka/auth';
import { constants } from '@pukka/common';

import { BillingModel } from '../../models';

const { MOKA_GOAUTH_SERVICE } = constants;

const BILLING_COUPON_API = `${MOKA_GOAUTH_SERVICE}/billing-coupon`;
const VERIFY_BILLING_COUPON_URL = (coupon: string) => `${BILLING_COUPON_API}/v2/coupons/${coupon}/verify`;

async function verifyBillingCoupon(coupon: string, params?: VerifyCouponRequest) {
  const resp = await axios.post(VERIFY_BILLING_COUPON_URL(coupon), params);

  return resp.data as {
    data: {
      benefit: BillingModel.CouponDiscount;
    };
  };
}

export { BILLING_COUPON_API, VERIFY_BILLING_COUPON_URL, verifyBillingCoupon };
